import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../common_components/StaticFooter";
import StaticHeader from "../common_components/staticHeader";
import $ from 'jquery'
import { toastError } from "../../../utils/constants";
import { getCurrentAwardDetails_action } from '../../../actions/static_action/currentAwardDetails_action'

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            awardList: []
        };
    }

    componentDidMount() {
        this.loadscript()
        this.getCurrentAwardDetails()
    }

    getCurrentAwardDetails() {
        this.setState({ isLoading: true })

        this.props.getCurrentAwardDetails_action(null)
            .then((data) => {
                if (data.error != 1) {
                    const array = this.processAwardsData(data.awardList)
                    console.log("array------------->", array)
                    this.setState({ isLoading: false, awardList: array })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    processAwardsData(awardList) {
        let parentIDCounter = 0;
        let groupCounters = {};
        let groupIndexCounters = {};
        let processedData = [];
        let currentSectionLabel = null;

        awardList.forEach((award) => {
            let processedAward = { ...award };
            if (award.section_label !== currentSectionLabel) {
                currentSectionLabel = award.section_label;
                processedData.push({
                    isSectionLabelRow: true,
                    section_label: currentSectionLabel,
                });
            }
            if (award.award_name.startsWith("Textile Engineering & Technology Champion")) {
                if (!groupCounters["Textile Engineering & Technology Champion"]) {
                    groupCounters["Textile Engineering & Technology Champion"] = ++parentIDCounter;
                    groupIndexCounters["Textile Engineering & Technology Champion"] = 0;
                }
                processedAward.ParentID = groupCounters["Textile Engineering & Technology Champion"];
                groupIndexCounters["Textile Engineering & Technology Champion"]++;
                processedAward.index = `${processedAward.ParentID}.${groupIndexCounters["Textile Engineering & Technology Champion"]}`;
            } else if (award.award_name.startsWith("Honoring Women")) {
                if (!groupCounters["Honoring Women"]) {
                    groupCounters["Honoring Women"] = ++parentIDCounter;
                    groupIndexCounters["Honoring Women"] = 0;
                }
                processedAward.ParentID = groupCounters["Honoring Women"];
                groupIndexCounters["Honoring Women"]++;
                processedAward.index = `${processedAward.ParentID}.${groupIndexCounters["Honoring Women"]}`;
            } else {
                processedAward.ParentID = ++parentIDCounter;
                processedAward.index = null;
            }
            processedData.push(processedAward);
        });

        return processedData;
    }


    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    onAwardApply(id) {
        this.props.navigate('/category', { state: { award_event_profile_id: id, isAllCategory: false } })
    }

    render() {
        const { awardList } = this.state;
        return (
            <>
                <StaticHeader />
                <>
                    <div className="website">
                        <section className="banner page-banner position-relative pb-0">
                            <div className="overlay"></div>
                            <div className="container">
                                <div className="page-title text-center position-relative py-9">
                                    <h2 className="text-white text-uppercase mt-4">India ITME Awards</h2>
                                </div>
                            </div>
                        </section>
                        <section className="conference" style={{ paddingBottom: 60 }}>
                            <div className="container">
                                <div className="conference-inner text-center">
                                    <div className="row gx-lg-5 align-items-center">
                                        <div className="col-lg-5 order-2 order-lg-1">
                                            <div className="conference-left ">
                                                <div className="row align-items-center">
                                                    <div className="col-lg-6 col-md-6 px-2 pt-2">
                                                        <iframe src="../static/pdf/Letter_for_Inviting_Applications.pdf" height={450} width={500} ></iframe>
                                                    </div>
                                                   
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-7 order-1 order-lg-2">
                                            <div className="event-benifit-list-right text-lg-start">
                                                <div className="overview-title pb-2">
                                                    {/* <p className="mb-1 pink">About India ITME Awards</p> */}
                                                    <h2 className="mb-2">
                                                        India ITME Awards
                                                    </h2>
                                                </div>
                                                <div className="overview-info text-justify">
                                                    <p>
                                                        Every edition of India ITME Society awards will try to do
                                                        justice and grow bigger, better &amp; bolder by introducing
                                                        strategic categories and reaching a wider audience.
                                                    </p>
                                                    <p className="mb-0">
                                                        ITME Technical Awards are more than just symbols of
                                                        recognition; they are powerful tools for motivation,
                                                        appreciation, and acknowledgment of achievements. Whether in a
                                                        corporate setting, academic institution, creative industry, or
                                                        community organization, ITME awards play a critical role in
                                                        inspiring individuals and teams to strive for excellence. They
                                                        serve to highlight outstanding contributions, celebrate hard
                                                        work, and set benchmarks for success. Spreading its wings
                                                        across boundaries, the 3rd edition will be a creator of
                                                        milestones with participation from across the Globe. These
                                                        awards transcend national boundaries, celebrating excellence.
                                                        Global exposure amplifies their significance, making them
                                                        highly sought after and respected worldwide.
                                                    </p>
                                                    <p className="mb-0">
                                                        Winning India ITME Awards will be an accelerator for the
                                                        growth of engineering firms. India ITME Society’s wide network
                                                        will not only enhance the company’s reputation amongst the
                                                        fellow industry but among the most prestigious customer
                                                        industry of the sector.{" "}
                                                    </p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="container ">
                            <h4 className="text-left mb-2 text-capitalize fw-normal">Awards List</h4>
                            <table className="table award-tab">
                                <tbody>

                                    {awardList.length > 0 ?
                                        <>
                                            {awardList.map((data, index) => {
                                                // Render section label rows
                                                if (data.isSectionLabelRow) {
                                                    return (
                                                        <tr key={`section-${index}`} >
                                                            <td colSpan="3" style={{ textAlign: "center", fontWeight: "bold", backgroundColor: "#67b2b4", color: 'white' }}>
                                                                {data.section_label}
                                                            </td>
                                                        </tr>
                                                    );
                                                }

                                                // Handle ParentID grouping and rowspan logic
                                                const prevParentID = index > 0 ? awardList[index - 1].ParentID : null;
                                                const isSameParentID = data.ParentID === prevParentID;
                                                let rowSpan = 1;

                                                if (!isSameParentID) {
                                                    rowSpan = awardList.filter((item) => item.ParentID === data.ParentID).length;
                                                }

                                                return (
                                                    <tr key={data.award_event_profile_id}>
                                                        {/* Render ParentID only once per group */}
                                                        {data.ParentID != null && !isSameParentID && (
                                                            <td
                                                                rowSpan={rowSpan}
                                                                style={{ verticalAlign: "middle" }}
                                                                className="text-center"
                                                            >
                                                                {data.ParentID}
                                                            </td>
                                                        )}
                                                        <td className="text-center">
                                                            {data.index || ''}
                                                        </td>
                                                        <td>
                                                            <a onClick={() => this.onAwardApply(data.award_event_profile_id)}>
                                                                {data.award_name}
                                                            </a>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            <tr>
                                                <td style={{ textAlign: "center", fontWeight: "bold", backgroundColor: "#67b2b4", color: 'white' }} colSpan={3}>Recognition for Extra Ordinary Contribution to the Industry</td>

                                            </tr>
                                        </>
                                        : <tr>
                                            <td
                                                rowSpan={12}
                                                style={{ verticalAlign: "middle", }}
                                                className="text-center"
                                            >
                                                Record Not Found
                                            </td>
                                        </tr>}
                                </tbody>
                            </table>
                        </div>
                        <br />
                    </div>
                </>
                <StaticFooter />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, { getCurrentAwardDetails_action })(About)
);
